import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './account.css';

function AccountPage({ onNavigateToJobs }) {
  const { user, login, logout } = useAuth();
  const [tab, setTab] = useState('login');
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const endpoint = tab === 'login' ? '/api/auth/login' : '/api/auth/register';
    const body = tab === 'login'
      ? { email: form.email, password: form.password }
      : { username: form.username, email: form.email, password: form.password };
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Something went wrong'); return; }
      login(data.token, data.user);
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  if (user) {
    return (
      <div className="account-page">
        <div className="account-card">
          <h2 className="account-username">{user.username}</h2>
          <p className="account-email">{user.email}</p>
          <p className="account-since">Member since {new Date(user.created_at).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
          <div className="account-actions">
            <button className="account-btn-secondary" onClick={() => onNavigateToJobs({})}>Browse Jobs</button>
            <button className="account-btn-logout" onClick={logout}>Sign out</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="account-page">
      <div className="account-card">
        <h2 className="account-card-title">ferl</h2>
        <p className="account-card-sub">jobs worth reading about</p>

        <div className="account-tabs">
          <button className={tab === 'login' ? 'active' : ''} onClick={() => { setTab('login'); setError(''); }}>Sign in</button>
          <button className={tab === 'register' ? 'active' : ''} onClick={() => { setTab('register'); setError(''); }}>Create account</button>
        </div>

        <form onSubmit={submit} className="account-form">
          {tab === 'register' && (
            <input name="username" placeholder="Username" value={form.username} onChange={update} required autoComplete="username" />
          )}
          <input name="email" type="email" placeholder="Email" value={form.email} onChange={update} required autoComplete="email" />
          <input name="password" type="password" placeholder="Password" value={form.password} onChange={update} required autoComplete={tab === 'login' ? 'current-password' : 'new-password'} />
          {error && <p className="account-error">{error}</p>}
          <button type="submit" className="account-btn-primary" disabled={loading}>
            {loading ? '...' : tab === 'login' ? 'Sign in' : 'Create account'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AccountPage;
